import React, { useContext, useMemo } from 'react'

import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { MaccsInternshipContext } from '../../../../Context/InternshipsManager/MaccsInternshipProvider'
import { MaccsInternshipsDataContext } from '../../../../Context/InternshipsManager/MaccsInternshipsDataProvider'
import { getUser } from '../../../../reducers/UserReducer'
import { REFUSED, ROLE_ADMIN_HOSPITAL_RO } from '../../../../utils/constants'
import Selector from '../../../shared/Selectors/Selector'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClinicMedical, faGraduationCap, faSchool, faUserGraduate } from '@fortawesome/free-solid-svg-icons'
import { InstitutionGroupContext } from '../../../../Providers/InstitutionGroupProvider'

const NO_SCHOOL_TEXT = 'Without school'
const NO_STUDENT_TEXT = 'Without student'
const NO_INTERNSHIP_YEAR_TEXT = 'Without internship year'
const NO_SPECIALITY_TEXT = 'Without speciality'
const SCHOOL_STYLE = {
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'left',
  marginBottom: '0px'
}

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale),
    user: getUser(state.getUser)
  }
}

const InstitutionGroupInternshipData = ({ displaySectorSelector, internship, t, user }) => {
  const { institutions } = useContext(InstitutionGroupContext)
  const { specialities } = useContext(MaccsInternshipsDataContext)
  const { onUpdate } = useContext(MaccsInternshipContext)

  const textualData = useMemo(() => {
    return {
      school: internship.school ? internship.school.name : t(NO_SCHOOL_TEXT),
      assistant: internship.assistant ? `${internship.assistant.lastname} ${internship.assistant.firstname}` : t(NO_STUDENT_TEXT),
      internshipYear: internship.internshipYear ? internship.internshipYear.studyYearName : t(NO_INTERNSHIP_YEAR_TEXT),
      speciality: internship.schoolSpeciality ? internship.schoolSpeciality.specialityYear.specialityAbbreviation : t(NO_SPECIALITY_TEXT)
    }
  }, [internship, t])

  return (
    <div className='internship-info-old'>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '25px' }}> <FontAwesomeIcon icon={faUserGraduate} /> </div>

        <b>{textualData.assistant}</b>&nbsp; - {textualData.speciality}
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '25px' }}> <FontAwesomeIcon icon={faSchool} /> </div>
        <p style={SCHOOL_STYLE}> {textualData.school} </p>
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '25px' }}> <FontAwesomeIcon icon={faGraduationCap} /> </div>
        <Selector
          data={specialities}
          dataKey='abbreviation'
          disabled={
            specialities.length === 0 ||
            user.roles.includes(ROLE_ADMIN_HOSPITAL_RO) ||
            internship.state === REFUSED
          }
          onSelect={value => onUpdate({ speciality: value === -1 ? null : value })}
          showArrow={false}
          showSearch
          value={internship.speciality ? internship.speciality.id : -1}
          style={{ width: '250px' }}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '25px' }}> <FontAwesomeIcon icon={faClinicMedical} /> </div>
        <Selector
          data={institutions}
          dataKey='name'
          disabled={internship.state === REFUSED}
          onSelect={value => onUpdate({ institution: value === -1 ? null : value })}
          showArrow={false}
          showSearch
          value={internship.institution ? internship.institution.id : -1}
          style={{ width: '250px' }}
        />
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(InstitutionGroupInternshipData)
